/// <amd-module name="Wit/WorkItemModel/WorkItem/LegacyTfsConnection" />
import { IVssPageContext } from "VSS/Platform/Context";
import { ILegacyTfsConnection } from "Wit/WorkItemModel/OM/ILegacyWorkItem";
import { LegacyTfsClient } from "./LegacyTfsClient";

export class LegacyTfsConnection implements ILegacyTfsConnection {
    private _client: LegacyTfsClient;

    constructor(pageContext: IVssPageContext) {
        this._client = new LegacyTfsClient(pageContext);
    }

    public getHttpClient(_: any): LegacyTfsClient {
        return this._client;
    }
}
